import { MonthWeekDayDiv } from '@blcloud/bl-datamodel/enum/bizcmn/month-week-day-div';

/** 設定識別ID */
export const SCREEN_ACTION_SETTING_ID = 'screen-action-setting';

/**
 * 受付一覧初期表示設定インターフェース定義
 */
export interface IReceptSearchScreenActionSetting {
  /** 日付検索範囲 何日前から（0＝今日） */
  searchDateRangeStartDays: number;
  /** 日付検索範囲 何日後まで（0＝今日） */
  searchDateRangeEndDays: number;
  /** 月週日区分（開始用） */
  monthWeekDayDivStart?: string;
  /** 月週日区分（終了用） */
  monthWeekDayDivEnd?: string;
  /** 検索対象日時の種類 */
  searchTargetDateType?: string;
  /** 受付状況（商談ステータス）のリスト */
  bizNegoStatusList?: string[];
}

/** 日付検索範囲のデフォルト（1ヶ月前から今日まで） */
export const DEFAULT_SEARCH_DATE_RANGE_START_DAYS = -1;
export const DEFAULT_SEARCH_DATE_RANGE_END_DAYS = 0;

/** 検索対象日時のデフォルト（受付日） */
export const DEFAULT_SEARCH_TARGET_DATE_TYPE = 'reception';

/** 月週日区分のデフォルト（開始用: ヶ月、終了用: 日） */
export const DEFAULT_MONTH_WEEK_DAY_DIV_START = MonthWeekDayDiv.Month;
export const DEFAULT_MONTH_WEEK_DAY_DIV_END = MonthWeekDayDiv.Day;

/** 日付範囲の上限（検索条件バリデーションに合わせて1ヶ月以内） */
export const SEARCH_DATE_RANGE_MAX_DAYS = 31;

/**
 * ベースとなる受付一覧初期表示設定
 */
export const BaseScreenActionSetting: IReceptSearchScreenActionSetting = {
  searchDateRangeStartDays: DEFAULT_SEARCH_DATE_RANGE_START_DAYS,
  searchDateRangeEndDays: DEFAULT_SEARCH_DATE_RANGE_END_DAYS,
  monthWeekDayDivStart: DEFAULT_MONTH_WEEK_DAY_DIV_START,
  monthWeekDayDivEnd: DEFAULT_MONTH_WEEK_DAY_DIV_END,
  searchTargetDateType: DEFAULT_SEARCH_TARGET_DATE_TYPE,
  bizNegoStatusList: [],
};



// WEBPACK FOOTER //
// ./src/app/page/recept-list-page/modal/recept-search-screen-action-setting-modal/recept-search-screen-action-setting-modal.define.ts